import {Component, OnInit} from '@angular/core';
import {AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {debounceTime, distinctUntilChanged, takeUntil} from 'rxjs/operators';
import {BaseFieldType} from 'compob2b-libs';

interface SmartlistItem {
  key: string;
  value: string;
}

@Component({
    selector: 'app-smartlist',
    templateUrl: './smartlist.component.html',
    standalone: false
})
export class SmartlistComponent extends BaseFieldType implements OnInit {
  smartlistForm = new UntypedFormGroup({
    items: new UntypedFormArray([])
  });

  get items() {
    return this.smartlistForm.get('items') as UntypedFormArray;
  }

  ngOnInit(): void {
    if (this.field.defaultValue !== null && this.field.defaultValue !== undefined) {
      const smartlist: SmartlistItem[] = JSON.parse(this.field.defaultValue);
      if (smartlist) {
        smartlist.forEach(item => this.items.push(this.newSmartlistItem(item.key, item.value)));
      }
    }

    this.smartlistForm.get('items').valueChanges
      .pipe(
        takeUntil(this.unsubscribe),
        debounceTime(300),
        distinctUntilChanged(),
      )
      .subscribe(data => {
        this.formControl.setValue(JSON.stringify(data.filter(item => item.key && item.value)));
        this.formControl.markAsTouched();
      });
  }

  addSmartlistItem(): void {
    this.items.push(this.newSmartlistItem(null, null));
  }

  deleteSmartlistItem(itemIndex: number): void {
    this.items.removeAt(itemIndex);
  }

  private newSmartlistItem(key: string, value: string): AbstractControl {
    return new UntypedFormGroup({
      key: new UntypedFormControl(key, Validators.required),
      value: new UntypedFormControl(value, Validators.required),
    });
  }
}
